/*
 * @Description: 路由
 * @Author: zml
 * @Date: 2023-04-19 19:42:50
 * @LastEditors: zml
 * @LastEditTime: 2023-04-26 16:45:31
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store/index"

import homePage from '@/views/home'
import loginPage from '@/views/login'

Vue.use(VueRouter)
// 解决 NavigationDuplicated: Avoided redundant navigation to current location 报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const routes = [{
    path: '/',
    redirect: '/login'
}, {
    name: 'login',
    path: '/login',
    component: loginPage,
    meta: {
        keepAlive: false
    }
}, {
    name: 'home',
    path: '/home',
    component: homePage,
    meta: {
        keepAlive: false
    }
}]

const router = new VueRouter({
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }

    }
})


router.beforeEach((to, from, next) => {
    let obj = store.state.tenant
    if (obj.tenantInfo.id && obj.token) {
        if (to.name === 'login') {
            next('/home')
        } else {
            next()
        }
    } else {
        if (to.name === 'login') {
            next()
        } else {
            next('/')
        }
    }
})
export default router